let idList = '';
let that = this;

// 查询动态资讯id
$.ajax({
	url: '/api/admin/official/exc/infoDynamic',
	type: 'GET',
	dataType: 'json',
	success: function (res) {
		that.idList = res.data.infoIdList;
		getInformation();
	},
});
const nav = $('#information').text();
// 查询首页资讯详情
function getInformation() {
	$.ajax({
		url: '/api/admin/official/exc/information/detailByIds',
		type: 'POST',
		contentType: 'application/json; charset=UTF-8',
		processData: false,
		data: JSON.stringify(that.idList),
		dataType: 'json',
		success: function (res) {
			const list = res.data.records;
			let imgList = '';
			let contents = '';
			let newList = list.map(
				(item) =>
					`<div class="swiper-slide"><img src= ${item.coverUrl} style="width: 100%;max-height: 600px" /></div>`
			);
			$('.swiper-wrapper').html(newList.join(' '));

			new Swiper('.swiper-container', {
				loop: true, // 循环模式选项
				autoplay: {
					delay: 100000,
				}, //可选选项，自动滑动

				// 如果需要前进后退按钮
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
			$.each(list, function (i) {
				if (list[i].subtitle === null) {
					list[i].subtitle = '';
				}
				// 左侧banner
				// imgList += `<div class="swiper-slide">
				//               <img src= ${list[i].coverUrl} />
				//             </div>`
				// $(".swiper-wrapper").html(imgList)

				// 右侧列表
				if (list[i].linkType === 0 || list[i].linkType === null) {
					contents += `<a class="new-list__item item" href="informationDetail.html?idx=0&id=${encodeURI(
						list[i].id
					)}&nav=${encodeURI(nav)}">
                            <div class="new-info">
                                <p class="new-title">${list[i].title}</p>
                                <p class="new-des">${list[i].subtitle}</p>
                            </div>
                            <div class="new-time">${list[i].publicTime}</div>
                        </a>`;
					$('.content-box').html(contents);
				} else {
					contents += `<a class="new-list__item item" href="${list[i].linkUrl}" target=_blank>
                                <div class="new-info">
                                    <p class="new-title">${list[i].title}</p>
                                    <p class="new-des">${list[i].subtitle}</p>
                                </div>
                                <div class="new-time">${list[i].publicTime}</div>
                            </a>`;
					$('.content-box').html(contents);
				}
			});
		},
	});
}
